import TermContainer from "./TermContainer";
import withRenderOnPermissionActive from "../../../../hocs/withRenderOnPermissionActive";

export default withRenderOnPermissionActive(TermContainer, [
  "general-settings-global-terms",
]);
